module.exports = __webpack_public_path__ + "static/media/light-insta-icon.1afcd890.svg";